import {BasicCompanyInformation} from './registerTrialRequest';
import {TenantInvite} from './tenantInvite';


export class CreateOrganizationRequest {
  companyInformation: BasicCompanyInformation;
  users: TenantInvite[];
}
